import _ from "lodash";
import { SET_ERROR_MESSAGE, REMOVE_ERROR_MESSAGE } from "../constants";

export function setErrorMessage(message) {
  return (dispatch, getState) => {
    const state = getState();
    const { errors } = state.errors;
    errors.push(message);
    dispatch({
      type: SET_ERROR_MESSAGE,
      payload: {
        data: errors
      }
    });
  };
}

export function removeErrorMessage(message) {
  return (dispatch, getState) => {
    const state = getState();
    const { errors } = state.errors;
    _.remove(errors, err => {
      return err.id === message.id;
    });
    dispatch({
      type: REMOVE_ERROR_MESSAGE,
      payload: {
        data: errors
      }
    });
  };
}
